import { useCallback } from "preact/compat";
import Modal from "~/components/modal.tsx";
import useAppDispatch from "~/hooks/use-app-dispatch.ts";
import useAppSelector from "~/hooks/use-app-selector.ts";
import { selectUser } from "~/features/user/selectors.ts";
import { seenSignUpWelcome } from "~/features/user/store-slice.ts";
import { useTranslator } from "@brickme/frontend-common/src/i18n/translation.tsx";

type JustSignedUpModalProps = {
	readonly show: boolean;
};

function JustSignedUpModal({ show }: JustSignedUpModalProps) {
	const dispatch = useAppDispatch();
	const t = useTranslator();
	const onSkip = useCallback(() => {
		dispatch(seenSignUpWelcome());
	}, [dispatch]);
	const user = useAppSelector(selectUser);
	const title = (() => {
		if (user.type === "signedIn" && user.user.firstName) {
			return t("Welcome, {firstName}!", { firstName: user.user.firstName });
		}
		return t("Welcome!");
	})();

	return (
		<Modal
			title={title}
			show={show}
			slimBorder
			bodyClassName="just-signed-up-modal__body-tight"
		>
			<Modal.Text>
				{t(
					"Thanks for joining! You're all set - start by picking your image on the next page. We've sent you an email to verify your account. You can keep going for now, but you'll need to verify before your next login. If you don't see the email, please check your spam folder.",
				)}
			</Modal.Text>
			<Modal.Actions
				actions={[{ text: t("Choose image"), onClick: onSkip, type: "ghost" }]}
			/>
		</Modal>
	);
}

export default JustSignedUpModal;
